import React from "react";
import { Car, Truck, Users } from "lucide-react";
import { VEHICLES } from "../../data/tarifas";
import { eur } from "../../lib/pricing";
import { Section, StepBadge } from "./ui";

const vehicleIcon = { car: Car, van: Truck, passengers: Users };

export default function VehicleStep({ group, onSelect }) {
  return (
    <Section>
      <StepBadge n={1} title="Elige tu vehículo" subtitle={`${VEHICLES.length} grupos disponibles`} />
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {VEHICLES.map((v) => {
          const Icon = vehicleIcon[v.icon] || Car;
          const active = group === v.group;
          return (
            <button
              key={v.group}
              type="button"
              onClick={() => onSelect(v.group)}
              className={`text-left rounded-xl border p-3.5 flex gap-3 transition-all duration-200 ${
                active
                  ? "border-[#631024] bg-[#fbeef1] shadow-sm"
                  : "border-[#ece0e3] bg-white hover:border-[#d9c3c8] hover:shadow-sm"
              }`}
            >
              <span className={`shrink-0 w-11 h-11 rounded-lg flex items-center justify-center ${active ? "bg-white" : "bg-[#f8ecef]"}`}>
                <Icon className="w-5 h-5 text-[#631024]" />
              </span>
              <div className="min-w-0">
                <div className="flex items-start gap-2">
                  <span className="mt-0.5 inline-flex items-center justify-center w-5 h-5 rounded bg-[#2a1a1e] text-white text-[11px] font-bold shrink-0">{v.group}</span>
                  <span className="font-display font-bold text-[#2a1a1e] leading-tight">{v.name}</span>
                </div>
                <p className="text-xs text-[#9b8388] mt-0.5">{v.type} · {v.detail}</p>
                <p className="text-sm font-semibold text-[#631024] mt-1">desde {eur(v.weekday)} <span className="text-[#9b8388] font-normal">/ día</span></p>
              </div>
            </button>
          );
        })}
      </div>
    </Section>
  );
}
